var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"np-fade"}},[(_vm.error)?_c('p',{staticClass:"np-form-error"},[_vm._t("default",[_vm._v(_vm._s(_vm.error))])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }